import { RootState } from '@store';

export const selectArticles = (state: RootState) => {
  return state.article?.articles;
};
